'use client';
import { darkGray, darkOrange, gray, lightGray, lightOrange, orange, white } from './colors';
export const themeOptions = {
    app: {
        background: '#f0f4f7'
    },
    typography: {
        h1: {
            fontSize: '3rem',
            fontWeight: 700
        },
        h2: {
            fontSize: '2.5rem',
            fontWeight: 600
        },
        h3: {
            fontSize: '2rem',
            fontWeight: 500
        },
        h4: {
            fontSize: '1.5rem',
            fontWeight: 400
        },
        h5: {
            fontSize: '1.25rem',
            fontWeight: 400
        },
        h6: {
            fontSize: '1rem',
            fontWeight: 500
        }
    },
    components: {
        MuiLink: {
            styleOverrides: {
                root: {
                    fontWeight: 400
                }
            }
        }
    },
    palette: {
        primary: {
            main: orange,
            light: lightOrange,
            dark: darkOrange,
            contrastText: white
        },
        secondary: {
            main: gray,
            light: lightGray,
            dark: darkGray,
            contrastText: white
        }
    }
};
